import styled from 'styled-components';

const StyledItineraryBlock = styled.div`
  padding: 4rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const StyledSubtitle = styled.div`
  color: ${(props) => props.theme.color.primary};
  padding: 0.5rem 1rem;
  border: 2px solid ${(props) => props.theme.color.primary};
  border-radius: ${(props) => props.theme.radius.md};
`;

const StyledSelectedAccommodationChoice = styled.div`
  margin-top: 1.5rem;
  width: 90%;

  h3 {
    margin-left: -1.5rem;
  }
`;

const StyledAccommodationBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90%;
  align-items: flex-start;
  border-radius: ${(props) => props.theme.radius.md};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: 0px 0px 20px 0px #a6adb340;
  padding: 1.5rem;
  gap: 1rem;
`;

const StyledFlexbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const StyledTag = styled.div`
  border: 1px solid #ebebeb;
  border-radius: ${(props) => props.theme.radius.md};
  background-color: #fafafa;
  padding: 0.25rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  width: fit-content;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const StyledStar = styled.div`
  color: #db6c3a;
  font-size: 1rem;
  margin-right: 0.5rem;
`;

const StyledRow = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding-bottom: 2rem;
  font-weight: 600;
  color: ${(props) => props.theme.color.bodyTextColor};
`;

const StyledContentGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  width: 100%;
  row-gap: 1.5rem;
  column-gap: 0.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  // Show only one column on mobile for just the main image
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledMoreImagesButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.7rem;
  width: fit-content;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: ${(props) => props.theme.color.white};
  border: 1px solid ${(props) => props.theme.color.bodyTextColor};
  color: ${(props) => props.theme.color.bodyTextColor};
  border-radius: ${(props) => props.theme.radius.md};
  cursor: pointer;
  position: absolute;
  top: 21.6rem;
  right: 1rem;
`;

const StyledExtras = styled.div`
  display: grid;
  grid-template-columns: 0.75fr 1fr;

  background-color: #fafafa;
  border: 1px solid #ebebeb;
  border-radius: ${(props) => props.theme.radius.md};
  padding: 20px 32px;
  margin: 0 1rem;

  @media (max-width: 768px) {
    padding: 20px 12px;
  }
`;

const StyledUpgradeLabel = styled.div`
  display: flex;
  justify-content: center;
  width: 120px;
  position: absolute;
  top: 78px;
  right: -22px;
  background-color: #db6c3a;
  color: white;
  padding: 5px 10px;
  transform: rotate(45deg);
  transform-origin: top right;
  z-index: 1;

  clip-path: polygon(78% 0%, 100% 100%, 0% 100%, 22% calc(100% - 30px));

  .top {
    display: flex;
    justify-content: center;
    width: 8px;
    height: 8px;
    position: absolute;
    // background-color: #b64817;
    transform: rotate(45deg);
  }

  .bottom {
    display: flex;
    justify-content: center;
    width: 8px;
    height: 8px;
    position: absolute;
    top: 78px;
    right: -22px;
    background-color: #b64817;
    transform: rotate(45deg);
  }
`;

const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0 1rem;
`;

export {
  StyledItineraryBlock,
  StyledSubtitle,
  StyledSelectedAccommodationChoice,
  StyledAccommodationBlock,
  StyledFlexbox,
  StyledRow,
  StyledContentGrid,
  StyledExtras,
  StyledUpgradeLabel,
  StyledButtons,
  StyledMoreImagesButton,
  StyledTag,
  StyledStar,
};
